<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10 flex align-center">
        <div class="flex grey darken-1">
          <div
            v-if="storeInfo.brand_name || storeInfo.name_short"
            class="m-r-5"
            v-text="storeInfo.brand_name ? storeInfo.brand_name : storeInfo.name_short ? store.brand_name : ''"
          />
          <div
            v-if="storeInfo.name_short"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="storeInfo.name_short"
            v-text="storeInfo.name_short"
          />
        </div>
      </div>
      <div class="col-md-12">
        <store-form
          :info="info"
          @update:store-info="updateStoreInfo"
        />
      </div>
    </div>
  </section>
</template>

<script>
import storeForm from './Temp/StoreFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      },
      storeInfo: {
        brand_name: '',
        name_short: ''
      }
    }
  },
  components: {
    'store-form': storeForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  methods: {
    updateStoreInfo (storeInfo) {
      const { brand_name: brandName, name_short: nameShort } = storeInfo
      this.storeInfo.brand_name = brandName
      this.storeInfo.name_short = nameShort
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpStore.vue?70b80e6c